import { GAME_YEARS } from '../data/constants.js';
import { DEMAND_BY_YEAR } from '../data/demand.js';
import { formatTwh } from './format.js';

export function YearStrip({
  year,
  subsidyActive,
  portfolioCount,
  action,
  demandLabel
}) {
  return (
    <div className="year-strip" role="region" aria-label="Year status">
      <div className="year-strip-row">
        <span className="year-strip-label">Year</span>
        <span className="year-strip-value">
          {year} of {GAME_YEARS}
        </span>
      </div>
      <div className="year-strip-row">
        <span className="year-strip-label">Demand</span>
        <span className="year-strip-value">
          {demandLabel ?? formatTwh(DEMAND_BY_YEAR[year])}
        </span>
      </div>
      <div className="year-strip-row">
        <span className="year-strip-label">Portfolio</span>
        <span className="year-strip-value">
          {portfolioCount} plant{portfolioCount === 1 ? '' : 's'}
        </span>
      </div>
      <div className="year-strip-row">
        <span className="year-strip-label">Fossil subsidy</span>
        <span
          className={
            'year-strip-chip ' +
            (subsidyActive ? 'year-strip-chip-on' : 'year-strip-chip-off')
          }
        >
          {subsidyActive ? 'Active' : 'Removed'}
        </span>
      </div>
      {action ? (
        <div className="year-strip-action">
          {action}
        </div>
      ) : null}
    </div>
  );
}
